package com.solevo.dist.viewmodels

import com.solevo.dist.application.models.Product
import com.solevo.dist.network.api.products.ProductRemoteSource
import com.solevo.dist.network.api.user.UserRemoteSource
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.launch
import org.koin.mp.KoinPlatform.getKoin

data class ProductDetailsUi(
    val loading: Boolean = true,
    val error: String? = null,
    val product: Product? = null
)

class ProductDetailsViewModel(productId: String) {
    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
    private val productSource: ProductRemoteSource = getKoin().get()
    private val userRemoteSource: UserRemoteSource = getKoin().get()

    private val _state = MutableStateFlow(ProductDetailsUi())
    val state: StateFlow<ProductDetailsUi> = _state.asStateFlow()

    @OptIn(ExperimentalCoroutinesApi::class)
    fun start(productId: String) {
        _state.value = _state.value.copy(loading = true, error = null)
        scope.launch {
            userRemoteSource.currentUser()
                .filterNotNull()
                .flatMapLatest {
                    productSource.getProductDetailsLive(productId)
                }
                .catch { t ->
                    println("[ProductDetailsVM] Error loading product $productId: ${t.message}")
                    _state.value = _state.value.copy(loading = false, error = t.message ?: "Unknown error")
                }
                .collectLatest { product ->
                    println("[ProductDetailsVM] Loaded product successfully: id=${product.productId}")
                    _state.value = _state.value.copy(loading = false, error = null, product = product)
                }
        }
    }
}


